import {useContext, useEffect} from "react";
import { StepperContext } from "./context/StepperContext";
import { Step } from "./FormStepper";


export const Stepper = (props: {steps: Step[]}) => {
    const stepperState= useContext(StepperContext);
    useEffect(() => {
        if (stepperState.setSteps)
            stepperState.setSteps(props.steps);
    }, [props.steps]);
    return <div>
        {stepperState.steps[stepperState.currentStepIdx]?.element||<div>Wait</div>}
    </div>
}